module.exports = __webpack_public_path__ + "res/img/bg.570f3dc0.jpg";